import { Component, Inject } from '@angular/core';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { MasterDetailListEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { StructureSelectionContext } from '../../../structure-selection.model';

@Component({
    selector: 'app-structure-selection-dialog',
    templateUrl: './structure-selection-dialog.component.html',
    styleUrls: ['./structure-selection-dialog.component.scss']
})
export class StructureSelectionDialogComponent {

    stationGroups: Array<StationGroup>;

    selectedStationGroup: StationGroup = null;

    selectionValid = false;

    constructor(
        public translationService: TranslationService,
        private dialog: MatDialogRef<StructureSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: StructureSelectionContext,
    ) {

        data.validation$.subscribe(validation => {
            this.selectionValid = validation;
        });
    }

    onSelectionChanged(entry: MasterDetailListEntry) {
        const stationGroup = entry as StationGroup;
        this.data.setStationGroupSelection(stationGroup.id);
    }

    confirmDialog() {
        this.data.validation$.unsubscribe();
        this.dialog.close(this.data.selection);
    }

    cancelDialog() {
        this.data.validation$.unsubscribe();
        this.dialog.close(null);
    }

}
